import { render, staticRenderFns } from "./PictureDetails.vue?vue&type=template&id=b053fdbc&scoped=true"
import script from "./PictureDetails.vue?vue&type=script&lang=js"
export * from "./PictureDetails.vue?vue&type=script&lang=js"
import style0 from "./PictureDetails.vue?vue&type=style&index=0&id=b053fdbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b053fdbc",
  null
  
)

export default component.exports